module.exports = __webpack_public_path__ + "static/media/petunjuk_profil.41e78dbf.png";